import React, { Component } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {availableLanguages} from '../../translations';
import {setAgentLanguage, setLanguageBackend} from '../../actions/getAgentConfig';
import ca_flag from '../../assets/img/flags/ca.png';
import en_flag from '../../assets/img/flags/en.png';
import es_flag from '../../assets/img/flags/es.png';
import pt_flag from '../../assets/img/flags/pt.png';
import fr_flag from '../../assets/img/flags/fr.png';
import nl_flag from '../../assets/img/flags/nl.png';
import classnames from 'classnames';
import { logData } from '../../utils/utils';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

class ChangeLanguageModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
			isShow: false,
      showErr: false,
			showModal:props.showModal,
      language: this.props.selectedLanguage,
      flags: {
        ca: ca_flag,
        en: en_flag,
        es: es_flag,
        pt: pt_flag,
        fr: fr_flag,
        nl: nl_flag
      }
		};
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.selectedLanguage!==nextProps.selectedLanguage){
      this.changeLanguage(nextProps.selectedLanguage);
    }
  }
  handleEnter = () => {
    this.setState({
      language: this.props.selectedLanguage,
    });
  }
  close = (key) => {
    this.setState({
      showErr: false
    }, () => {
      this.props.handleClose(key);
    });
  }
  // updates state with selected language
  changeLanguage = (language) => {
    this.setState({
      language
    });
  }
  // updates new selected language
  handleSubmit = () => {
    this.props.setLanguageBackend(this.state.language)
    const agent_id = localStorage.getItem("agent_id");
    const client_id = localStorage.getItem("clientId");
    
    window.mq.send(`/exchange/signal.${client_id}/user.${agent_id}`, {}, `{"tag":"lang_change","data" : "${this.state.language}"}`)
    
    this.props.setAgentLanguage(this.state.language).then((res) => {
      if(res.data.result){
        this.props.handleClose(this.props.showModal);
        
      }else{
        this.setState({
          showErr: true,
          errorMsg: res.data.description || this.props.translations.commonErrorText[this.props.selectedLanguage]
        });
      }
    }, (err) => {
      logData(err);
      this.setState({
        showErr: true,
        errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage]
      });
    });
  }

  handleAlertDismiss = () => {
    this.setState({
      showErr: false
    });
  }

  render(){
    const { translations, selectedLanguage } = this.props;
    return (
      <Modal
        show={this.props.showModal}
        onEnter={this.handleEnter}
        onHide={() => this.close('showModal')}
        bsSize="sm"
        backdrop="static"
      >
        <Modal.Header className={`modal-content${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>{translations.language[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`}>
          {this.state.showErr && <div className="alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
            <p>{this.state.errorMsg}</p>
          </Alert></div>}
          <div className="list-group">
            {availableLanguages.map(item => (
              <button
                key={item.code}
                type="button"
                onClick={() => this.changeLanguage(item.code)}
                className={classnames(`list-group-item list-group-item${this.props.theme}`, {active: this.state.language==item.code})}
              >
                {/* <span
                  className="lang-xs lang-lbl"
                  lang={item.code} /> */}
                <img src={this.state.flags[item.code]} style={ { marginBottom: 3, marginRight: 5 } } />
                <span>{item.name}</span>
              </button>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button type="button" onClick={() => this.close('showModal')} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">{translations.cancel[selectedLanguage]}</button>
          <button type="submit" onClick={this.handleSubmit} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">
            <strong>{translations.save[selectedLanguage]}</strong>
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps  (state) {
    return {
        agentInfo: state.agentInfo,
        translations: state.languages.translations,
        selectedLanguage: state.languages.selectedLanguage,
        darkMode: state.common.darkMode,
        theme: state.common.theme,
    };
}

function mapDispatchToProps (dispatch) {
    return bindActionCreators({setAgentLanguage, setLanguageBackend}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeLanguageModal);



// WEBPACK FOOTER //
// ./src/agent/modals/changeLanguage.js